<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <!-- Alert message -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <div>
      <HeaderComponent
        :headerTitle="headerText"
        :router-link="{ name: 'RetunrCreation' }"
        :router-link-text="'Return / Claim Requests'"
        :return-condition="true"
        :component-name="'Warranty Claim Request'"
      />
    </div>
    <!-- search invoice -->
    <v-row justify="center">
      <v-dialog v-model="searchInvoicePopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 m-0">
            <v-card-title class="d-flex align-center">
              <span>Reference Document</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="text" @click="closeSearchInvoicePopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-card-text>
            <v-container>
              <v-col cols="6" sm="12" md="12" style="height: 96px">
                <v-text-field
                  label="For Eg: INV-098-RT-097"
                  prepend-inner-icon="mdi-magnify"
                  variant="outlined"
                  v-model="search_invoice"
                  color="primary"
                  style="margin-bottom: -30px"
                  required
                ></v-text-field>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              :color="!search_invoice ? '' : 'primary' "
              class="mb-3"
              variant="flat"
              @click="invoiceItemDataPopup"
              :disabled="!search_invoice"
              >GO</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Request details -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="text" @click="successpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3" @click="afterClickOkLoadData"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- submit success message -->
    <v-row justify="center">
      <v-dialog
        v-model="returncreateionsuccesspopup"
        persistent
        max-width="424px"
      >
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn icon variant="text" @click="returncreateionsuccesspopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ returncreationsuccessmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="mb-3"
              variant="flat"
              @click="redirectToreturncreation"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Search invoice items popup -->
    <v-row justify="center">
      <v-dialog
        v-model="invoiceItemPopup"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title class="alert-link">{{ req_id }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions>
            <!-- :color="this.selected_manf.length == 0 ? 'gray' : 'white'" -->
            <v-btn
              size="small"
              :color="this.selected_manf.length == 0 ? 'primary' : 'white'"
              variant="flat"
              :disabled="this.selected_manf.length == 0"
              @click="addItem"
              >ADD Items</v-btn
            >
            <v-btn icon dark variant="text" @click="invoiceItemPopup = false"
              ><v-icon color="white">mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-toolbar>
        <v-card class="v-card-100 m-0">
          <v-layout column>
                <v-data-table hover
                  density="compact"
                  show-select
                  :search="search"
                  :hide-default-footer="true"
                  v-model="selected_manf"
                  :headers="edit_req_headers"
                  :items="edit_req_table_data"
                  disable-pagination
                  :items-per-page="pageSize"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                  return-object
                >
                <template #bottom></template>
                </v-data-table>
          </v-layout>
          <v-container fluid>
            <v-row class="m-0 mb-10">
              <v-spacer></v-spacer>
              <v-col cols="12"  sm="12" md="6" class="d-flex justify-end gap-3">
                <div style="width: 6rem;">
                  <v-select
                    v-model="pageSize"
                    :items="[]"
                    label="Items Per Page"
                    color="primary"
                    variant="underlined"
                    ></v-select>
                    <!-- @update:modelValue="handlePageSizeChange" -->
                </div>
                <v-pagination density="comfortable" elevation="2"
                  v-model="page"
                  :length="totalPages"
                  total-visible="7"
                  next-icon="mdi-menu-right"
                  prev-icon="mdi-menu-left"
                  active-color="bg-primary" 
                  ></v-pagination>
                  <!-- @update:modelValue="handlePageChange" -->
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  -->
    <v-card class="v-card-100 text-left">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="1" sm="4" md="4">
            <span style="font-weight: 500">Request Details</span>
          </v-col>
          <v-col cols="8" sm="4" md="4">
            <v-combobox
              v-model="item_location"
              :items="item_location_items"
              item-title="original_code"
              return-object
              color="primary"
              item-value=""
              label="Item Location*"
              variant="outlined"
              class="ma-2"
              @update:modelValue="changeLocation"
            ></v-combobox>
          </v-col>
          <v-col
            cols="9"
            sm="4"
            md="4"
            v-if="
              item_location && item_location.original_code === 'Location ID'
            "
          >
            <v-text-field
              v-model="location_id"
              color="primary"
              label="Location ID*"
              variant="outlined"
              class="ma-2"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="v-card-100 border-top text-left">
      <v-card-text>
        <v-row class="returnmb">
          <v-col cols="1" sm="4" md="4">
            <span style="font-weight: 500">Return Item Details</span>
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-combobox
              v-model="select_method"
              :items="select_method_items"
              item-title="original_code"
              color="primary"
              item-value="id"
              return-object
              label="Select Method"
              variant="outlined"
              class="ma-2"
              @update:modelValue="changeSelectedMethod"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row
          style="margin-bottom: -20px"
          v-if="
            select_method &&
            select_method.original_code === 'Article ID & Serial Number'
          "
        >
          <v-col cols="12" sm="4" md="4"> </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-text-field
              v-model="article_id"
              label="Article ID*"
              color="primary"
              variant="outlined"
              class="ma-2"
            ></v-text-field>
            <v-btn
              class="ma-2 color-change"
              @click="addSerialNumber"
              color="#ffff"
              >+ Add Article Id & Serial Number</v-btn
            >
          </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-text-field
              v-model="serial_number"
              label="Serial Number*"
              color="primary"
              variant="outlined"
              class="ma-2"
            ></v-text-field>
          </v-col>
          <div v-if="searchedData">
            <p>Article ID: {{ searchedData.article_id }}</p>
            <p>Serial Number: {{ searchedData.serial_number }}</p>
          </div>
          <div v-if="error">
            <p>Error: {{ error }}</p>
          </div>
        </v-row>
        <v-row
          style="margin-bottom: -20px"
          v-if="select_method && select_method.original_code === 'Article ID'"
        >
          <v-col cols="12" sm="4" md="4"> </v-col>
          <v-col cols="13" sm="4" md="4">
            <v-text-field
              v-model="article_id2"
              label="Article ID*"
              color="primary"
              variant="outlined"
              class="ma-2"
              @keyup.enter="fetchData('Article ID')"
            ></v-text-field>
            <div v-if="articleId !== null">
              <div class="selected_rule_box">
                <span
                  v-for="(dataItem, index) in articleId"
                  :key="dataItem.id"
                  class="rule-type_option"
                >
                  <template v-if="dataItem.sku_code">
                    {{ dataItem.sku_code }}
                    <v-icon small @click="removeItem(dataItem, index)"
                      >mdi-close</v-icon
                    >
                  </template>
                  <template v-else>
                    Article ID {{ dataItem.sku_code }} does not exist in data
                  </template>
                </span>
              </div>
            </div>
            <v-btn
              class="ma-2 color-change"
              @click="addSerialNumber"
              color="#ffff"
              >+ Add Another Article Id</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4"> </v-col>
          <v-col
            cols="13"
            sm="4"
            md="4"
            v-if="
              select_method && select_method.original_code === 'Serial Number'
            "
          >
            <v-text-field
              v-model="serial_number2"
              label="Serial Number*"
              variant="outlined"
              color="primary"
              class="ma-2"
              @input="validateSerialNumber"
              :error-messages="serialNumberErrorMessages"
              @keyup.enter="fetchData('Serial Number')"
            ></v-text-field>
            <div v-if="weatherData !== null">
              <div class="selected_rule_box">
                <span
                  v-for="(dataItem, index) in weatherData"
                  :key="dataItem.id"
                  class="rule-type_option"
                >
                  <template v-if="dataItem.serial_number">
                    {{ dataItem.serial_number }}
                    <v-icon small @click="removeItem(dataItem, index)"
                      >mdi-close</v-icon
                    >
                  </template>
                </span>
              </div>
            </div>
            <v-btn
              class="ma-2 color-change"
              @click="addSerialNumber"
              color="#ffff"
              >+ Add Another</v-btn
            >
          </v-col>
        </v-row>
        <v-row style="margin-bottom: -10px">
          <v-col cols="12" sm="4" md="4"> </v-col>
          <v-col cols="13" sm="3" md="3">
            <v-btn
              v-if="this.selectedAddItem.length > 0"
              class="ma-2 color-change"
              @click="openDialogSearchInVoice"
              color="#ffff"
              >+ ADD ANOTHER INVOICE</v-btn
            >
            <br />
            <span
              v-if="this.selectedAddItem.length > 0"
              style="margin-left: 10px"
              >Items Selected:
              <u class="color-change">{{
                this.selectedAddItem.length
              }}</u></span
            >
          </v-col>
          <v-col style="margin-bottom: -10px"></v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="v-card-100 border-top text-left">
      <v-card-text>
        <v-row class="">
          <v-col cols="1" sm="4" md="4">
            <span style="font-weight: 500">Condition Details*</span>
          </v-col>
          <v-col cols="13" sm="8" md="8">
            <span class="ma-2"
              >What is the condition of the item (e.g. new, used,
              refurbished)?</span
            ><br />
            <v-row class="m-0">
              <v-col cols="14" sm="4" md="4">
                <label for="">
                  <input
                    class="inputfield ml-2"
                    type="radio"
                    value="New"
                    v-model="selectedValue"
                  />
                  <span class="titles">New</span>
                </label>
              </v-col>
              <v-col cols="14" sm="4" md="4">
                <label for="">
                  <input
                    class="inputfield"
                    type="radio"
                    value="User"
                    v-model="selectedValue"
                  />
                  <span class="titles">Used</span>
                </label>
              </v-col>
              <v-col cols="14" sm="4" md="4">
                <label for="">
                  <input
                    class="inputfield"
                    type="radio"
                    value="Refurbished"
                    v-model="selectedValue"
                  />
                  <span class="titles">Refurbished</span>
                </label>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="12" sm="8" md="8">
            <span class="ma-2">What is the brand and model of the item?</span
            ><br />
            <v-row class="m-0">
              <v-col cols="13" sm="6" md="6">
                <v-combobox
                  v-model="brand"
                  :items="brand_items"
                  item-title=""
                  item-value=""
                  color="primary"
                  label="Brand*"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col cols="13" sm="6" md="6">
                <v-combobox
                  v-model="model"
                  :items="model_items"
                  item-title=""
                  item-value=""
                  color="primary"
                  label="Model*"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="12" sm="8" md="8">
            <span class="ma-2"
              >What is the current market value of the item</span
            ><br />
            <v-row class="m-0">
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="value"
                  label="Value*"
                  color="primary"
                  variant="outlined"
                  class="ma-2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="12" sm="8" md="8">
            <span class="ma-2">Date Of Purchase</span><br />
            <v-row class="m-0">
              <v-col cols="12" sm="6" md="6" class="ma-2 time">
                <v-menu
                  ref="menu_14"
                  v-model="menu_14"
                  :close-on-content-click="false"
                  :return-value.sync="purchase_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  class="ma-2"
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      hide-details
                      v-model="purchase_date"
                      label="Date"
                      color="primary"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                    ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                  <v-date-picker
                  :max="new Date().toISOString().substr(0, 10)"
                  v-model="isDatePickerPurchase_date"
                  scrollable
                  class="ma-2" 
                  hide-header      
                  color="primary"
                  min-width="100"
                  max-width="300"
                  >
                  </v-date-picker>
                  <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                        <v-btn variant="text" color="primary" @click="menu_14 = false">Cancel</v-btn>
                        <v-btn variant="text" color="primary" @click="() => handleSaveDate('menu_14' , 'purchase_date', 'isDatePickerPurchase_date')"> OK </v-btn>
                  </v-card-action>
              </v-card>
                  <!-- <v-date-picker
                    :max="new Date().toISOString().substr(0, 10)"
                    v-model="purchase_date"
                    no-title
                    scrollable
                    class="ma-2"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu_14 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_14.save(purchase_date)"
                      >OK</v-btn
                    >
                  </v-date-picker> -->
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="12" sm="8" md="8">
            <span class="ma-2"
              >Are there any accessories or additional items included with the
              item?</span
            ><br />
            <v-row class="m-0">
              <v-col cols="14" sm="3" md="3">
                <label for="">
                  <input
                    class="inputfield ml-2"
                    type="radio"
                    value="yes"
                    v-model="answer"
                  />
                  <span class="titles">Yes</span>
                </label>
              </v-col>
              <v-col cols="14" sm="3" md="3">
                <label for="">
                  <input
                    class="inputfield"
                    type="radio"
                    value="no"
                    v-model="answer"
                  />
                  <span class="titles">No</span>
                </label>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="returnmb">
          <v-col cols="12" sm="4" md="4"></v-col>
          <v-col cols="8" sm="4" md="4">
            <v-file-input
              v-model="file"
              accept=""
              label="Images*"
              variant="underlined"
              color="primary"
              clear-icon="mdi-close"
              class="ma-2"
            ></v-file-input>
          </v-col>
          <v-col cols="9" sm="4" md="4">
            <v-file-input
              v-model="file_video"
              accept=""
              label="Videos*"
              clear-icon="mdi-close"
              color="primary"
              variant="underlined"
              class="ma-2"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            size='small'
            variant="flat"
            :color="number > 0 || !item_location || !select_method ? '' : 'primary'"
            style="margin-top: 18px"
            :disabled="number > 0 || !item_location || !select_method"
            @click="submitForm"
            >SUBMIT</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
import { mixinHelper } from "@//mixins/mixin-helper.js"; 

export default {
  mixins: [mixinHelper],

  data() {
    return {
      headerText: "Return Creation",
      alert_type: "",
      alert_message: "",
      alert: false,
      channel: "",
      channel_items: "",
      item_location: null,
      item_location_items: [],
      location_id: null,
      location_id_items: "",
      basedSelectMethod: false,
      select_method: null,
      select_method_items: [],
      selectedValue: "",
      answer: "",
      file: "",
      file_video: "",
      brand: null,
      brand_items: "",
      model: null,
      model_items: "",
      article_id: "",
      serial_number: "",
      purchase_date: "",
      isDatePickerPurchase_date: new Date(),
      menu_14: false,
      searchInvoicePopup: false,
      successpopup: false,
      successmessage: "",
      search_invoice: "",
      selectedAddItem: [],
      weatherData: null,
      articleId: null,
      value: "",
      invoiceItemPopup: false,
      returncreateionsuccesspopup: false,
      returncreationsuccessmessage: "",
      serialNumberErrorMessages: [],
      selected_manf: [],
      edit_req_headers: [
        { title: "Article Id", key: "sku_code" },
        { title: "Invoice Number", key: "reference_document_number" },
        { title: "Article Description", key: "sku_description" },
        { title: "Serial Number", key: "serial_number" },
      ],
      edit_req_table_data: [],
      loading:true
    };
  },
  components: {
    HeaderComponent,
  },
  async created() {
    this.returnRequestSubtype = this.$route.params.return_id;
    this.returntype = this.$route.params.return_value;
    this.fetchAllData();
  },
  methods: {
    handleSaveDate(dateType , dateState, selectDateState){
        this[dateState] = this.formatted_filter_date(this[selectDateState])
        this[dateType] = false
    },
    fetchAllData() {
      this.getlocation();
      this.returnDocumentKey();
    },
    loadData() {
      this.loading = true;
      this.selected_manf = [];
      this.edit_req_table_data = [];
      this.page = 1;
    },
    getlocation() {
      this.$httpSecured
        .get(
          `/api/v1/warehouse/return_initiation/master_values/return_creation_locations`,
        )
        .then((response) => {
          if (response.data) {
            this.item_location_items = response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    returnDocumentKey() {
      this.$httpSecured
        .get(
          `/api/v1/warehouse/return_initiation/master_values/return_creation_document_keys`,
        )
        .then((response) => {
          if (response.data) {
            this.select_method_items = response.data.lookup_values;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    changeLocation() {
      // if (this.item_location) {
      //   const selectedlocation = this.item_location.original_cod;
      //   if (selectedlocation === "Location ID") {
      //   }
      // }
    },
    // select method script
    changeSelectedMethod() {
      if (this.select_method) {
        const selectedId = this.select_method.original_code;
        if (selectedId === "Reference Document") {
          this.searchInvoicePopup = true;
        } else if (selectedId === "Serial Number") {
          this.selectedAddItem = [];
          this.additionalField = "";
        } else if (selectedId === "Article ID") {
          this.selectedAddItem = [];
        } else if (selectedId === "Article ID & Serial Number") {
          this.selectedAddItem = [];
        } else {
          this.additionalField = null;
        }
      }
    },
    validateSerialNumber() {
      this.serial_number2 = this.serial_number2.replace(/\D/g, "");

      if (this.serial_number2 === "" || isNaN(this.serial_number2)) {
        this.serialNumberErrorMessages = [
          "Please enter a valid numeric serial number.",
        ];
      } else {
        this.serialNumberErrorMessages = [];
      }
    },
    fetchData(searchType) {
      let searchData;

      if (searchType === "Article ID") {
        if (!this.article_id2) {
          return;
        }
        searchData = this.article_id2;
      } else if (searchType === "Serial Number") {
        if (!this.serial_number2) {
          return;
        }
        searchData = this.serial_number2;
      } else {
        return;
      }

      const formData = new FormData();
      formData.append("search_type", searchType);
      formData.append("search", searchData);

      this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items",
          formData,
        )
        .then((response) => {
          if (response.data) {
            if (searchType === "Article ID") {
              this.articleId = response.data.return_inventory_informations;
            } else if (searchType === "Serial Number") {
              this.weatherData = response.data.return_inventory_informations;
            }
          } else {
            if (searchType === "Article ID") {
              this.articleId = null;
            } else if (searchType === "Serial Number") {
              this.weatherData = null;
              this.showError = true;
            }
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert(
            "error",
            "Something went wrong from Network: " + error,
          );
        });
    },
    addSerialNumber() {
      if (this.serial_number2) {
        this.weatherData.push({
          serial_number: this.serial_number2,
          temperature: this.temperatureValue,
        });
        this.serial_number2 = "";
        this.temperatureValue = 0;
      } else if (this.article_id2) {
        this.articleId.push({
          article_id: this.article_id2,
          temperature: this.temperatureValue,
        });
        this.article_id2 = "";
        this.temperatureValue = 0;
      }
    },
    addItem() {
      this.selectedAddItem.push(this.selected_manf);
      this.invoiceItemPopup = false;
      this.searchInvoicePopup = false;
      if (this.selected_manf.length > 0) {
        this.successpopup = true;
        this.successmessage = `${this.selected_manf.length} Items are marked for Warranty Claim Request`;
      }
    },
    openDialogSearchInVoice() {
      this.searchInvoicePopup = true;
    },
    closeSearchInvoicePopup() {
      this.search_invoice = "";
      this.searchInvoicePopup = false;
      this.select_method = "";
    },
    invoiceItemDataPopup() {
      this.req_id = this.search_invoice;
      this.loading = true;
      this.selected_manf = [];
      this.edit_req_headers = [
        { title: "Article Id", key: "sku_code" },
        { title: "Invoice Number", key: "reference_document_number" },
        { title: "Article Description", key: "sku_description" },
        { title: "Serial Number", key: "serial_number" },
      ];

      const formData = new FormData();
      formData.append("search_type", "Reference Document");
      formData.append("search", this.search_invoice);
      // formData.append("page", this.page);
      // formData.append("perpage", this.pageSize);

      this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_inventory_informations/search_return_items",
          formData,
        )
        .then((response) => {
          if (response.data) {
            this.edit_req_table_data =
              response.data.return_inventory_informations;
            // this.totalPages = response.data.meta.total_pages;
            this.loading = false;
            this.invoiceItemPopup = true;
            this.search_invoice = "";
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    afterClickOkLoadData() {
      this.successpopup = false;
      this.successmessage = "";
    },
    submitForm() {
      this.returnData = this.selected_manf;
      const returnDetails = this.returnData.map((item) => ({
        return_inventory_information_id: item.id,
        quantity: item.quantity,
        sku_code: item.sku_code,
        reference_document_number: item.reference_document_number,
      }));

      const requestData = {
        return_item: {
          return_type: this.returntype,
          return_type_id: this.returnRequestSubtype,
          item_location: this.item_location,
          item_location_id: this.item_location.id,
          article_id: this.article_id2,
          serial_number: this.serial_number2,
          return_details: returnDetails,
        },
      };

      this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_creations",
          requestData,
        )
        .then((response) => {
          if (response.data) {
            this.returncreationsuccessmessage = response.data.message;
            this.returncreateionsuccesspopup = true;
            this.showAlert("success", response.data.message);
            this.loadData();
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.error);
          this.loading = false;
        });
    },
    redirectToreturncreation() {
      this.returncreateionsuccesspopup = false;
      this.returncreationsuccessmessage = "";
      this.$router.push({ name: "RetunrCreation" });
    },
    // select method script end
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
<style>
.returnmb {
  margin-bottom: -40px;
}
.border-top {
  border-top: 18px solid #e5e5e5 !important;
}
.inputfield {
  height: 15px;
  width: 15px;
  margin-right: 10px;
}
.titles {
  margin-bottom: 10px !important;
}

.return-class {
  position: absolute;
  left: 25px;
}
.time .v-input {
  max-width: 96%;
}

.rule-type_option {
  border: 1px solid #000000;
  padding: 4px 8px;
  border-radius: 5px;
  margin: 1px 2px;
}
</style>
